import AddCommitmentsToEqualisation from '../Editor/AddCommitmentsToEqualisation/index';
import { EqualisationProvider } from '../Editor/EqualisationContext';
import { EqualisationSection } from 'further-types/lp/equalisation';
import { useLayoutContext } from 'contexts/LayoutContext';

const AddEqualisation: React.FC = () => {
  const { vehicle } = useLayoutContext();

  if (!vehicle) return null;

  return (
    <EqualisationProvider
      baseCurrency={vehicle.baseCurrency}
      initialSection={EqualisationSection.Commitments}
      sections={[EqualisationSection.Commitments]}
      commitments={[]}
    >
      <AddCommitmentsToEqualisation />
    </EqualisationProvider>
  );
};

export default AddEqualisation;
